import React from 'react'
import {Link, withRouter} from "react-router-dom";
import {Header} from "antd/es/layout/layout";
import { Layout, Menu, Breadcrumb, Col, Row } from 'antd';

import {persistor, store} from "./store";
import axios from 'axios';

function logout() {
  delete axios.defaults.headers.common['Authorization'];
  persistor.purge();
  store.dispatch({ type: 'RESET' });
  window.location.href='/';
}


class MainHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    menubarwidth: "100%"

  }

  isLoggedIn() {
    return this.props.session.email !== null
  }

  closeMobileNav() {
    this.setState({menubarwidth: "100%"})
  }


  render() {
    const { location } = this.props;

    if (location.pathname === "/login" || location.pathname === "/signup" || location.pathname === "/nickname") {
      return null
    } else {
      return(
          <Header>
            <Row>
            <Col span={1}>
            <img style={{
              width:'auto',
              height:'56px',
              left: '-27px',
              position: 'absolute',
              top: '3px',
            }} src='/snu_logo_white.png'/>
            </Col>
            <Col span={17} >
            {(!this.props.session)?
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
              <Menu.Item key="1">
                <Link to='/'>
                  E-portfolio</Link>
              </Menu.Item>
            </Menu>
            :''}
            {(this.props.session) && (this.props.session.role == 'student') ?
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
              <Menu.Item key="1">

                {!this.props.token ?
                <Link to='/login'>SNU CVM e-Portfolio</Link>
                :
                <Link to='/'>SNU CVM e-Portfolio</Link>
                }
                </Menu.Item>
              <Menu.Item key="2"  >
                {!this.props.token ?
                <Link to='/login'>신규 포트폴리오 작성</Link>
                :
                <Link to='/create'>신규 포트폴리오 작성</Link>
                }
              </Menu.Item>
              <Menu.Item key="3" >
                {!this.props.token ?
                <Link to='/login'>포트폴리오 리스트</Link>
                :
                <Link to ='/list'>포트폴리오 리스트</Link>
                }
                </Menu.Item>
              <Menu.Item key="4" >
                {!this.props.token ?
                <Link to='/login'>종합 포트폴리오 생성</Link>
                :
                <Link to ='/extract'>종합 포트폴리오 생성</Link>
                }
                </Menu.Item>
            </Menu>
            :
            ''}
          {(this.props.session.role === 'professor') || this.props.session.role === 'admin' ?
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
              {this.props.session.role === 'admin' && <Menu.Item key="0"><Link to="/admin_list">계정 관리</Link></Menu.Item>}
              <Menu.Item key="1">
                <Link to='/prof_list/waiting'>승인대기 실습</Link>
              </Menu.Item>
              <Menu.Item key="2">
                <Link to='/prof_list/rejected'>반려된 실습</Link>
              </Menu.Item>
              <Menu.Item key="3"  >
                <Link to='/prof_list/done'>승인완료 실습</Link>
              </Menu.Item>
              <Menu.Item key="4"  >
                <Link to='/portfolio_list'>신청된 포트폴리오 </Link>
              </Menu.Item>
            </Menu>
            :''}
            </Col>
            <Col  span={5} >
            <Menu theme="dark" mode="horizontal" >
              {
              this.props.session.id ?
              <>
              <Menu.Item disabled > {{'professor': '교수', 'student': '학생'}[this.props.session.role]} | {this.props.session.name}</Menu.Item>
              <Menu.Item><Link to='/change_password'>비밀번호 변경</Link></Menu.Item>
              <Menu.Item link='/logout' onClick={() => {
                logout()}}><Link to='/logout'>로그아웃</Link></Menu.Item>
              </>
              :
              <></>
              }
            </Menu>
            </Col>
            </Row>
          </Header>
        )
      }
    }
  }
  export default withRouter(MainHeader)
